class Constants {
  readonly pageSize: number = 10;
  readonly WHATSAPP: string = 'WhatsApp';
  readonly WHATSAPP_MESSAGE: string = 'Mensaje WhatsApp';
  readonly WHATSAPP_BUTTON_HOVER_MESSAGE: string = '¿Necesitas ayuda? ¡Estamos en WhatsApp!';

  readonly envRelease = 'release';
  readonly colorDevelop = 'd32f2f';
  readonly colorRelease = 'ffa000';
  readonly inactivityLogoutTimeoutMs = 10 * 60 * 1000;
  readonly whatsappLink: string = 'https://wa.me';
  readonly sectionsFileLimit: number = 4;
  readonly productsFileLimit: number = 5;
  readonly productsImportExtensions: string = '.xls, .xlsx, .csv';
  readonly inventoryImportExtensions: string = '.xls, .xlsx';
  readonly productsImagesImportExtensions: string = '.zip';
  readonly validateAddress: RegExp = /^(?:(?:Calle|Cl|Carrera|Cra|Avenida|Av|Diagonal|Diag|Dg|Transversal|Transv|Trv)\s?\d+[A-Za-z]?(?:\s?(?:N|S|E|O|Norte|Sur|Este|Oeste))?\s?(?:#|No\.?)\s?(?:Diagonal|Diag|Dg|Transversal|Transv|Trv|Calle|Cl|Carrera|Cra)?\s?\d+[A-Za-z]?\s?-\s?\d+(?:\s?(?:Sur|Norte|Este|Oeste))?)$/i
  readonly defaultCantInventory: number = 2;
}

const constants = new Constants();
export default constants;
